// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpTabContent ::ng-deep .p-button.p-button-icon-only {
  height: 36px;
  width: 40px !important;
  margin-left: 20px;
}
#bdpTabContent ::ng-deep .favoritePanel ::ng-deep div.p-tooltip .p-tooltip-text {
  background-color: #ecf2ff;
  position: fixed;
}
#bdpTabContent ::ng-deep .favoritePanel ::ng-deep div.p-tooltip.p-component {
  top: -15px !important;
}
#bdpTabContent ::ng-deep .favoritePanel ::ng-deep div.p-tooltip.p-component .p-tooltip-arrow {
  top: 25px !important;
  border-left-color: #ecf2ff;
  border-right-color: #ecf2ff;
}
#bdpTabContent ::ng-deep .mobile-view {
  float: left;
}
#bdpTabContent ::ng-deep .mobile-view .export-list {
  width: min-content;
  margin-right: 26px;
  list-style-type: none;
  padding: 0px;
  position: absolute;
  right: 0px;
  margin-top: 5px;
  display: none;
  box-shadow: 0px 0px 5px 0px rgba(68, 68, 68, 0.4784313725);
  z-index: 9999;
}
#bdpTabContent ::ng-deep .mobile-view .export-list.bdp-active {
  border-radius: 8px;
  display: block;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header {
  background-color: #fff;
  padding: 0px;
  margin-bottom: 0px;
  border-radius: 8px;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item {
  text-align: left;
  font-size: 14px !important;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .list-width {
  width: 180px;
  color: #19181a;
  font-size: 14px;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .active-btn:last-child {
  background: #f8f7fa;
  padding: 6px 20px;
  color: #2d74ff;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item li {
  margin-bottom: 8px;
  font-size: 14px;
  cursor: pointer;
  padding: 6px 20px;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item li:hover {
  background: #f8f7fa;
  padding: 6px 20px;
  color: #2d74ff;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list {
  width: -moz-fit-content;
  width: fit-content;
  display: block;
  height: 300px;
  z-index: 99999;
  background: white;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list #datePicker {
  display: flex !important;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list .inputDate {
  position: relative;
  left: 20px;
  bottom: 32px;
  width: 120px;
  z-index: 9999999;
  border-width: 1px;
  text-align: center;
  border-radius: 8px;
  color: #19181a;
  font-weight: bold;
  font-family: "Montserrat";
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list .inputDate.bdp-start-date {
  border: none;
  background-color: #f8f7fa;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list .inputDate.bdp-end-date {
  border: 1px solid #7047eb;
  background-color: #fff;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list input:focus-visible {
  outline: none;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .export-time-period-list .arrowRight {
  position: relative;
  bottom: 30px;
  left: 20px;
  z-index: 9999999;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .layout-submenu-header .export-list-item .bdp-Save-button {
  background-color: #004ce1;
}
#bdpTabContent ::ng-deep .mobile-view .export-list #alertContent {
  width: 380px;
  height: 340px;
  overflow-y: auto;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .readAllNotification {
  cursor: pointer;
  border-top-style: solid;
  border-top-width: 0.1px;
  border-top-color: #e3e4ec;
  text-decoration: underline;
  color: #2d74ff;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .readAllNotification:hover {
  color: #004ce1;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .origin-region.list-item {
  margin-bottom: 5px;
}
#bdpTabContent ::ng-deep .mobile-view .export-list .destination-region.list-item {
  margin-bottom: 5px;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .p-dialog {
  max-width: 560px !important;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .p-dialog .p-dialog-header {
  justify-content: space-between !important;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .p-dropdown {
  width: 160px;
  text-align: left;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-filter-active button.p-button {
  background-color: #004ce1;
  color: #fff;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-add-vessel button.p-button {
  background-color: #2d74ff;
  color: white;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-Save-button {
  margin: auto;
  background-color: #2d74ff;
  color: #fff;
  border-color: #2d74ff;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-show-history button.p-button {
  background-color: #2d74ff;
  color: white;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-show-history button.p-button:focus {
  box-shadow: none;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-show-view button.p-button {
  background-color: white;
  color: black;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .bdp-show-view button.p-button:focus {
  box-shadow: none;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep button.p-button {
  background-color: var(--bdpButtonSecondary);
  color: var(--bdpFontPrimary);
  border: 1px solid #d7d8d9;
  width: 160px;
  height: 36px;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep button.p-button.bdp-export-button {
  width: 36px;
  height: 36px;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep button.p-button.bdp-export-button .pi-refresh {
  font-weight: bold;
  color: #2d74ff;
  transform: rotate(20deg);
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep button.p-button.bdp-selected-button {
  background-color: #2d74ff;
  color: #fff;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep button.p-button.bdp-save-button {
  margin: auto;
  background-color: #2d74ff;
  color: #fff;
  border-color: #2d74ff;
}
#bdpTabContent ::ng-deep .mobile-view ::ng-deep .md-drppicker.shown {
  font-family: "Montserrat";
  font-size: 13px;
  color: #19181a;
}
#bdpTabContent ::ng-deep .mobile-view input .p-inputtext .p-component {
  width: 320px;
}
#bdpTabContent ::ng-deep .csr-subscribed .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background-color: var(--bdpPrimaryLightBlue);
  opacity: 0.5;
}
#bdpTabContent ::ng-deep .csr-not-subscribed .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background-color: #1b74c5;
}
#bdpTabContent ::ng-deep .p-input-icon-left > .p-inputtext {
  width: 220px !important;
}
#bdpTabContent ::ng-deep .p-datatable.p-datatable-customers .bdp-column-visibility .p-multiselect {
  min-width: 220px !important;
  width: 100%;
  max-width: none;
}
#bdpTabContent ::ng-deep .p-datatable.p-datatable-customers .bdp-column-visibility .p-multiselect .p-disabled {
  background-color: #757575;
  color: #fff;
}
#bdpTabContent ::ng-deep .p-datatable.p-datatable-customers .bdp-column-visibility .p-multiselect .p-disabled .p-checkbox-box {
  background-color: #757575;
}
#bdpTabContent ::ng-deep .p-datatable {
  background-color: white;
  padding: 24px !important;
}
#bdpTabContent ::ng-deep .p-tag {
  border-radius: 10rem !important;
  background: #1d2125;
}
#bdpTabContent ::ng-deep .p-multiselect-item span {
  word-break: break-word;
  word-wrap: break-word;
  word-spacing: initial;
  overflow-wrap: break-word;
  white-space: break-spaces;
}
#bdpTabContent ::ng-deep .p-button:enabled:hover {
  color: var(--bdpFontLight);
  background-color: var(--bdpButtonSecondary);
  border: 1px solid #1b74c5;
}
#bdpTabContent .bdp-header-container {
  overflow: hidden;
  width: 100%;
  white-space: pre-line;
  color: #1d2125;
}
#bdpTabContent .bdp-table-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#bdpTabContent .check-icon {
  font-size: 12px;
  color: #03a17b;
}
#bdpTabContent .table-header {
  display: flex;
  justify-content: space-between;
}
#bdpTabContent .table-header .bdp-table-heading {
  width: auto;
  float: left;
  margin: 0px;
  font-size: 16px;
}
#bdpTabContent .table-header .bdp-expand {
  width: 24px;
  height: 24px;
  text-align: center;
  color: #1b74c5;
  cursor: pointer;
  margin: 0px 10px;
  padding-top: 2px;
  float: right;
}
#bdpTabContent .table-header .bdp-export-wrapper {
  float: right;
}
#bdpTabContent .table-header .bdp-column-visibility {
  float: right;
  width: 300px;
}
#bdpTabContent .table-header .bdp-column-visibility .p-multiselect {
  width: 100%;
}
#bdpTabContent .table-header .inFont {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin-left: 20px;
  margin-right: 20px;
}
#bdpTabContent .table-header .bdp-page-elem {
  background-color: #fff;
  padding: 10px;
  height: 100%;
  max-height: 700px;
  overflow-y: scroll;
  padding-bottom: 15px;
  overflow: hidden;
}
#bdpTabContent .table-header .inactive {
  float: right;
  margin: -15px;
  margin-right: -25px;
  top: 0;
  font-size: 20px;
  background: white;
}
#bdpTabContent .table-header .active {
  float: right;
  margin: -15px;
  margin-right: -25px;
  top: 0;
  font-size: 20px;
  color: #0080ff;
}
#bdpTabContent .table-header .left-timeline {
  float: right;
  margin-top: -20px;
  margin-right: 8px;
  text-align: right;
}
#bdpTabContent .table-header .right-timeline {
  margin-top: -20px;
  margin-left: 4px;
  text-align: left;
}
#bdpTabContent .table-header .box-height {
  height: 15vh;
}
#bdpTabContent td.bdp-actions i {
  width: 32px;
  height: 32px;
  overflow: hidden;
  border-radius: 50%;
  cursor: pointer;
}

.divider {
  border-bottom-style: solid;
  border-bottom-width: 0.1px;
  border-bottom-color: #a8a8a8;
}

::ng-deep #bdpCustomRank .p-component.p-dialog {
  width: 432px !important;
}
::ng-deep #bdpCustomRank .p-component.p-dialog .p-dialog-content input {
  width: 98%;
}

#badge ::ng-deep .p-tag {
  border-radius: 10rem !important;
  color: white;
  font-weight: normal;
}
#badge .green {
  background: #03a17b;
}
#badge .orange {
  background: #f58331;
}
#badge .blue {
  background: #2f80ed;
}
#badge .grey {
  background: var(--bdpInactive);
}

#scroll-bar {
  padding-left: 0px !important;
  padding-left: 0px !important;
  overflow-x: auto;
  overflow-y: hidden;
}
#scroll-bar .timeline > li.complete:first-child .status::after {
  background-color: #0080ff;
  border: none;
  width: 12px;
  height: 12px;
  content: "";
  border-radius: 25px;
  position: absolute;
  top: -8px;
  left: 0;
  transition: all 200ms ease-in;
}
#scroll-bar .timeline > li.incomplete:first-child .status::after {
  background-color: #0080ff;
  border: none;
  width: 12px;
  height: 12px;
  content: "";
  border-radius: 25px;
  position: absolute;
  top: -8px;
  left: 0;
  transition: all 200ms ease-in;
}
#scroll-bar .bdp-view-details {
  border-top: 2px solid #ddd;
  text-align: center;
  display: inline-block;
  width: 100%;
}

::ng-deep .p-dialog .p-dialog-footer button {
  width: 184px;
}
::ng-deep .p-dialog .p-dialog-footer .bdp-save {
  background-color: #2d74ff;
}
::ng-deep .p-dialog .p-dialog-footer .bdp-reset {
  color: #1d2125;
  background-color: #fff;
  border-color: #1d2125;
}
::ng-deep #timeline div.p-overlaypanel {
  z-index: 1;
  width: 870px;
}
::ng-deep #timeline div.p-overlaypanel::after {
  content: "";
}
::ng-deep #timeline div.p-overlaypanel::before {
  content: "";
}
::ng-deep #timeline div.p-overlaypanel .p-overlaypanel-close {
  background: none;
  color: black;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: 0.4rem;
  right: 0.2rem;
}
::ng-deep #timeline div.p-overlaypanel #bdpTimelineNoData {
  color: #282c30;
  margin: 30px 20px;
  white-space: pre-line;
  font-size: 14px;
}
::ng-deep div.p-overlaypanel {
  z-index: 1;
}
::ng-deep div.p-overlaypanel::after {
  content: "";
}
::ng-deep div.p-overlaypanel::before {
  content: "";
}
::ng-deep div.p-overlaypanel .p-overlaypanel-close {
  background: none;
  color: black;
  width: 2rem;
  height: 2rem;
  transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  position: absolute;
  top: 0.4rem;
  right: 0.2rem;
}
::ng-deep div.p-overlaypanel #bdpTimelineNoData {
  color: #282c30;
  margin: 30px 20px;
  white-space: pre-line;
  font-size: 14px;
}
::ng-deep .bdp-favorite-button-font {
  font-size: 12px;
}
::ng-deep .bdp-reset {
  color: #1d2125;
  background-color: #fff;
  border-color: #1d2125;
}
::ng-deep .bdp-save {
  background-color: #2d74ff;
}
::ng-deep .bdp-comment-length {
  justify-content: flex-start;
  margin-right: 50px;
  margin-top: 6px;
}
::ng-deep .bdp-action-menu {
  width: 265px;
}
::ng-deep .bdp-action-menu.p-menu .p-menuitem-link:not(.p-disabled):hover {
  background: var(--bdpButtonHover);
}
::ng-deep .bdp-action-menu.p-menu .p-menuitem-link:not(.p-disabled):hover .p-menuitem-text {
  color: #fff;
}

.add-comments-area textarea {
  width: 440px;
  font-size: 14px;
}

::ng-deep .p-column-filter-overlay {
  z-index: 99999 !important;
}

.p-input-icon-left i.pi {
  position: absolute !important;
  left: 2.75rem !important;
  z-index: 1 !important;
  margin-top: 8px !important;
  color: var(--text-color-secondary);
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/common-table/common-table.component.scss"],"names":[],"mappings":"AAEQ;EACI,YAAA;EACA,sBAAA;EACA,iBAAA;AADZ;AAMgB;EACI,yBAAA;EACA,eAAA;AAJpB;AAOgB;EACI,qBAAA;AALpB;AAQgB;EACI,oBAAA;EACA,0BAAA;EACA,2BAAA;AANpB;AAWQ;EACI,WAAA;AATZ;AAWY;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,0DAAA;EACA,aAAA;AAThB;AAWgB;EACI,kBAAA;EACA,cAAA;AATpB;AAYgB;EACI,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAVpB;AAYoB;EACI,gBAAA;EACA,0BAAA;AAVxB;AAYwB;EACI,YAAA;EACA,cAAA;EACA,eAAA;AAV5B;AAawB;EACI,mBAAA;EACA,iBAAA;EACA,cAAA;AAX5B;AAcwB;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AAZ5B;AAewB;EACI,mBAAA;EACA,iBAAA;EACA,cAAA;AAb5B;AAgBwB;EACI,uBAAA;EAAA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AAd5B;AAgB4B;EACI,wBAAA;AAdhC;AAoB4B;EACI,kBAAA;EAEA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;AApBhC;AAsBgC;EACI,YAAA;EACA,yBAAA;AApBpC;AAuBgC;EACI,yBAAA;EACA,sBAAA;AArBpC;AAyB4B;EACI,aAAA;AAvBhC;AA0B4B;EACI,kBAAA;EACA,YAAA;EAEA,UAAA;EACA,gBAAA;AAzBhC;AA6BwB;EACI,yBAAA;AA3B5B;AAgCgB;EACI,YAAA;EACA,aAAA;EACA,gBAAA;AA9BpB;AAiCgB;EACI,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,cAAA;AA/BpB;AAiCoB;EACI,cAAA;AA/BxB;AAqCoB;EACI,kBAAA;AAnCxB;AA0CoB;EACI,kBAAA;AAxCxB;AA+CgB;EACI,2BAAA;AA7CpB;AAgDgB;EACI,yCAAA;AA9CpB;AAmDgB;EACI,YAAA;EACA,gBAAA;AAjDpB;AAqDoB;EACI,yBAAA;EACA,WAAA;AAnDxB;AAwDoB;EACI,yBAAA;EACA,YAAA;AAtDxB;AA0DgB;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;AAxDpB;AA4DoB;EACI,yBAAA;EACA,YAAA;AA1DxB;AA6DoB;EACI,gBAAA;AA3DxB;AAgEoB;EACI,uBAAA;EACA,YAAA;AA9DxB;AAiEoB;EACI,gBAAA;AA/DxB;AAmEgB;EACI,2CAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAjEpB;AAmEoB;EACI,WAAA;EACA,YAAA;AAjExB;AAmEwB;EACI,iBAAA;EACA,cAAA;EACA,wBAAA;AAjE5B;AAqEoB;EACI,yBAAA;EACA,WAAA;AAnExB;AAsEoB;EACI,YAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;AApExB;AAwEgB;EACI,yBAAA;EACA,eAAA;EACA,cAAA;AAtEpB;AA0EY;EACI,YAAA;AAxEhB;AA+EQ;EACI,4CAAA;EACA,YAAA;AA7EZ;AAgFQ;EACI,yBAAA;AA9EZ;AAiFQ;EACI,uBAAA;AA/EZ;AAkFQ;EACI,2BAAA;EACA,WAAA;EACA,eAAA;AAhFZ;AAkFY;EACI,yBAAA;EACA,WAAA;AAhFhB;AAkFgB;EACI,yBAAA;AAhFpB;AAqFQ;EACI,uBAAA;EACA,wBAAA;AAnFZ;AAsFQ;EACI,+BAAA;EACA,mBAAA;AApFZ;AAwFY;EACI,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAtFhB;AA2FI;EACI,0BAAA;EACA,2CAAA;EACA,yBAAA;AAzFR;AA4FI;EACI,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;AA1FR;AA6FI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AA3FR;AA8FI;EACI,eAAA;EACA,cAAA;AA5FR;AA+FI;EACI,aAAA;EACA,8BAAA;AA7FR;AA+FQ;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;AA7FZ;AAgGQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA9FZ;AAqGQ;EACI,YAAA;AAnGZ;AAsGQ;EAEI,YAAA;EACA,YAAA;AArGZ;AAuGY;EAEI,WAAA;AAtGhB;AA0GQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAxGZ;AA2GQ;EACI,sBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAzGZ;AA4GQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,iBAAA;AA1GZ;AA6GQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;AA3GZ;AA8GQ;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;AA5GZ;AA+GQ;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AA7GZ;AAgHQ;EACI,YAAA;AA9GZ;AAmHQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAjHZ;;AAsHA;EACI,0BAAA;EACA,0BAAA;EACA,4BAAA;AAnHJ;;AAwHQ;EACI,uBAAA;AArHZ;AAwHgB;EACI,UAAA;AAtHpB;;AA8HI;EACI,+BAAA;EACA,YAAA;EACA,mBAAA;AA3HR;AA8HI;EACI,mBAAA;AA5HR;AA+HI;EACI,mBAAA;AA7HR;AAgII;EACI,mBAAA;AA9HR;AAgII;EACI,8BAAA;AA9HR;;AAkIA;EACI,4BAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AA/HJ;AAmIY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AAjIhB;AAsIY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AApIhB;AAyII;EACI,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AAvIR;;AA+IQ;EACI,YAAA;AA5IZ;AA+IQ;EACI,yBAAA;AA7IZ;AAgJQ;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;AA9IZ;AAmJQ;EACI,UAAA;EACA,YAAA;AAjJZ;AAwJY;EACI,WAAA;AAtJhB;AAyJY;EACI,WAAA;AAvJhB;AA0JY;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AAxJhB;AA2JY;EACI,cAAA;EACA,iBAAA;EAEA,qBAAA;EACA,eAAA;AA1JhB;AA+JI;EACI,UAAA;AA7JR;AAqKQ;EACI,WAAA;AAnKZ;AAsKQ;EACI,WAAA;AApKZ;AAuKQ;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AArKZ;AAwKQ;EACI,cAAA;EACA,iBAAA;EAEA,qBAAA;EACA,eAAA;AAvKZ;AA2KI;EACI,eAAA;AAzKR;AA4KI;EACI,cAAA;EACA,sBAAA;EACA,qBAAA;AA1KR;AA6KI;EACI,yBAAA;AA3KR;AA8KI;EACI,2BAAA;EACA,kBAAA;EACA,eAAA;AA5KR;AA+KI;EACI,YAAA;AA7KR;AA+KQ;EACI,iCAAA;AA7KZ;AA+KY;EACI,WAAA;AA7KhB;;AAoLI;EACI,YAAA;EACA,eAAA;AAjLR;;AAyLA;EACI,yBAAA;AAtLJ;;AAyLA;EACI,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,0BAAA;EACA,kCAAA;AAtLJ","sourcesContent":["#bdpTabContent {\n    ::ng-deep {\n        .p-button.p-button-icon-only {\n            height: 36px;\n            width: 40px !important;\n            margin-left: 20px;\n        }\n\n        .favoritePanel {\n            ::ng-deep {\n                div.p-tooltip .p-tooltip-text {\n                    background-color: #ecf2ff;\n                    position: fixed;\n                }\n\n                div.p-tooltip.p-component {\n                    top: -15px !important;\n                }\n\n                div.p-tooltip.p-component .p-tooltip-arrow {\n                    top: 25px !important;\n                    border-left-color: #ecf2ff;\n                    border-right-color: #ecf2ff;\n                }\n            }\n        }\n\n        .mobile-view {\n            float: left;\n\n            .export-list {\n                width: min-content;\n                margin-right: 26px;\n                list-style-type: none;\n                padding: 0px;\n                position: absolute;\n                right: 0px;\n                margin-top: 5px;\n                display: none;\n                box-shadow: 0px 0px 5px 0px #4444447a;\n                z-index: 9999;\n\n                &.bdp-active {\n                    border-radius: 8px;\n                    display: block;\n                }\n\n                .layout-submenu-header {\n                    background-color: #fff;\n                    padding: 0px;\n                    margin-bottom: 0px;\n                    border-radius: 8px;\n\n                    .export-list-item {\n                        text-align: left;\n                        font-size: 14px !important;\n\n                        .list-width {\n                            width: 180px;\n                            color: #19181a;\n                            font-size: 14px;\n                        }\n\n                        .active-btn:last-child {\n                            background: #f8f7fa;\n                            padding: 6px 20px;\n                            color: #2d74ff;\n                        }\n\n                        & li {\n                            margin-bottom: 8px;\n                            font-size: 14px;\n                            cursor: pointer;\n                            padding: 6px 20px;\n                        }\n\n                        & li:hover {\n                            background: #f8f7fa;\n                            padding: 6px 20px;\n                            color: #2d74ff;\n                        }\n\n                        .export-time-period-list {\n                            width: fit-content;\n                            display: block;\n                            height: 300px;\n                            z-index: 99999;\n                            background: white;\n\n                            #datePicker {\n                                display: flex !important;\n                            }\n\n                            // .custom-period-active {\n                            //     display: block;\n                            // }\n                            .inputDate {\n                                position: relative;\n                                //  top: -47px;\n                                left: 20px;\n                                bottom: 32px;\n                                width: 120px;\n                                z-index: 9999999;\n                                border-width: 1px;\n                                text-align: center;\n                                //  height: 35px;\n                                border-radius: 8px;\n                                color: #19181a;\n                                font-weight: bold;\n                                font-family: \"Montserrat\";\n\n                                &.bdp-start-date {\n                                    border: none;\n                                    background-color: #f8f7fa;\n                                }\n\n                                &.bdp-end-date {\n                                    border: 1px solid #7047eb;\n                                    background-color: #fff;\n                                }\n                            }\n\n                            input:focus-visible {\n                                outline: none;\n                            }\n\n                            .arrowRight {\n                                position: relative;\n                                bottom: 30px;\n                                //  top: -47px;\n                                left: 20px;\n                                z-index: 9999999;\n                            }\n                        }\n\n                        .bdp-Save-button {\n                            background-color: #004ce1;\n                        }\n                    }\n                }\n\n                #alertContent {\n                    width: 380px;\n                    height: 340px;\n                    overflow-y: auto;\n                }\n\n                .readAllNotification {\n                    cursor: pointer;\n                    border-top-style: solid;\n                    border-top-width: 0.1px;\n                    border-top-color: #e3e4ec;\n                    text-decoration: underline;\n                    color: #2d74ff;\n\n                    &:hover {\n                        color: #004ce1;\n                    }\n                }\n\n                .origin-region {\n\n                    &.list-item {\n                        margin-bottom: 5px;\n                    }\n\n                }\n\n                .destination-region {\n\n                    &.list-item {\n                        margin-bottom: 5px;\n                    }\n                }\n            }\n\n\n            ::ng-deep {\n                .p-dialog {\n                    max-width: 560px !important;\n                }\n\n                .p-dialog .p-dialog-header {\n                    justify-content: space-between !important;\n                }\n            }\n\n            ::ng-deep {\n                .p-dropdown {\n                    width: 160px;\n                    text-align: left;\n                }\n\n                .bdp-filter-active {\n                    button.p-button {\n                        background-color: #004ce1;\n                        color: #fff;\n                    }\n                }\n\n                .bdp-add-vessel {\n                    button.p-button {\n                        background-color: #2d74ff;\n                        color: white;\n                    }\n                }\n\n                .bdp-Save-button {\n                    margin: auto;\n                    background-color: #2d74ff;\n                    color: #fff;\n                    border-color: #2d74ff;\n                }\n\n                .bdp-show-history {\n                    button.p-button {\n                        background-color: #2d74ff;\n                        color: white;\n                    }\n\n                    button.p-button:focus {\n                        box-shadow: none;\n                    }\n                }\n\n                .bdp-show-view {\n                    button.p-button {\n                        background-color: white;\n                        color: black;\n                    }\n\n                    button.p-button:focus {\n                        box-shadow: none;\n                    }\n                }\n\n                button.p-button {\n                    background-color: var(--bdpButtonSecondary);\n                    color: var(--bdpFontPrimary);\n                    border: 1px solid #d7d8d9;\n                    width: 160px;\n                    height: 36px;\n\n                    &.bdp-export-button {\n                        width: 36px;\n                        height: 36px;\n\n                        .pi-refresh {\n                            font-weight: bold;\n                            color: #2d74ff;\n                            transform: rotate(20deg);\n                        }\n                    }\n\n                    &.bdp-selected-button {\n                        background-color: #2d74ff;\n                        color: #fff;\n                    }\n\n                    &.bdp-save-button {\n                        margin: auto;\n                        background-color: #2d74ff;\n                        color: #fff;\n                        border-color: #2d74ff;\n                    }\n                }\n\n                .md-drppicker.shown {\n                    font-family: \"Montserrat\";\n                    font-size: 13px;\n                    color: #19181a;\n                }\n            }\n\n            input .p-inputtext .p-component {\n                width: 320px;\n            }\n\n        }\n\n        #downloadInfo {}\n\n        .csr-subscribed .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n            background-color: var(--bdpPrimaryLightBlue);\n            opacity: .5;\n        }\n\n        .csr-not-subscribed .p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {\n            background-color: #1b74c5;\n        }\n\n        .p-input-icon-left>.p-inputtext {\n            width: 220px !important;\n        }\n\n        .p-datatable.p-datatable-customers .bdp-column-visibility .p-multiselect {\n            min-width: 220px !important;\n            width: 100%;\n            max-width: none;\n\n            .p-disabled {\n                background-color: #757575;\n                color: #fff;\n\n                .p-checkbox-box {\n                    background-color: #757575;\n                }\n            }\n        }\n\n        .p-datatable {\n            background-color: white;\n            padding: 24px !important;\n        }\n\n        .p-tag {\n            border-radius: 10rem !important;\n            background: #1d2125;\n        }\n\n        .p-multiselect-item {\n            span {\n                word-break: break-word;\n                word-wrap: break-word;\n                word-spacing: initial;\n                overflow-wrap: break-word;\n                white-space: break-spaces;\n            }\n        }\n    }\n\n    ::ng-deep .p-button:enabled:hover {\n        color: var(--bdpFontLight);\n        background-color: var(--bdpButtonSecondary);\n        border: 1px solid #1b74c5;\n    }\n\n    .bdp-header-container {\n        overflow: hidden;\n        width: 100%;\n        white-space: pre-line;\n        color: #1d2125;\n    }\n\n    .bdp-table-header-wrapper {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .check-icon {\n        font-size: 12px;\n        color: #03a17b;\n    }\n\n    .table-header {\n        display: flex;\n        justify-content: space-between;\n\n        .bdp-table-heading {\n            width: auto;\n            float: left;\n            margin: 0px;\n            font-size: 16px;\n        }\n\n        .bdp-expand {\n            width: 24px;\n            height: 24px;\n            text-align: center;\n            color: #1b74c5;\n            cursor: pointer;\n            margin: 0px 10px;\n            padding-top: 2px;\n            float: right;\n        }\n\n        .bdp-filter-elem {\n            // margin-right: 10px;\n        }\n\n        .bdp-export-wrapper {\n            float: right;\n        }\n\n        .bdp-column-visibility {\n            // margin-right: 10px;\n            float: right;\n            width: 300px;\n\n            .p-multiselect {\n       //         max-width: 200px;\n                width: 100%;\n            }\n        }\n\n        .inFont {\n            font-size: 16px;\n            font-weight: 400;\n            line-height: 20px;\n            margin-left: 20px;\n            margin-right: 20px;\n        }\n\n        .bdp-page-elem {\n            background-color: #fff;\n            padding: 10px;\n            height: 100%;\n            max-height: 700px;\n            overflow-y: scroll;\n            padding-bottom: 15px;\n            overflow: hidden;\n        }\n\n        .inactive {\n            float: right;\n            margin: -15px;\n            margin-right: -25px;\n            top: 0;\n            font-size: 20px;\n            background: white;\n        }\n\n        .active {\n            float: right;\n            margin: -15px;\n            margin-right: -25px;\n            top: 0;\n            font-size: 20px;\n            color: #0080ff;\n        }\n\n        .left-timeline {\n            float: right;\n            margin-top: -20px;\n            margin-right: 8px;\n            text-align: right;\n        }\n\n        .right-timeline {\n            margin-top: -20px;\n            margin-left: 4px;\n            text-align: left;\n        }\n\n        .box-height {\n            height: 15vh;\n        }\n    }\n\n    td.bdp-actions {\n        i {\n            width: 32px;\n            height: 32px;\n            overflow: hidden;\n            border-radius: 50%;\n            cursor: pointer;\n        }\n    }\n}\n\n.divider {\n    border-bottom-style: solid;\n    border-bottom-width: 0.1px;\n    border-bottom-color: #a8a8a8;\n}\n\n::ng-deep {\n    #bdpCustomRank {\n        .p-component.p-dialog {\n            width: 432px !important;\n\n            .p-dialog-content {\n                input {\n                    width: 98%;\n                }\n            }\n        }\n    }\n}\n\n#badge {\n    ::ng-deep .p-tag {\n        border-radius: 10rem !important;\n        color: white;\n        font-weight: normal;\n    }\n\n    .green {\n        background: #03a17b;\n    }\n\n    .orange {\n        background: #f58331;\n    }\n\n    .blue {\n        background: #2f80ed;\n    }\n    .grey {\n        background: var(--bdpInactive);\n    }\n}\n\n#scroll-bar {\n    padding-left: 0px !important;\n    padding-left: 0px !important;\n    overflow-x: auto;\n    overflow-y: hidden;\n\n    .timeline {\n        &>li.complete:first-child {\n            .status::after {\n                background-color: #0080ff;\n                border: none;\n                width: 12px;\n                height: 12px;\n                content: \"\";\n                border-radius: 25px;\n                position: absolute;\n                top: -8px;\n                left: 0;\n                transition: all 200ms ease-in;\n            }\n        }\n\n        &>li.incomplete:first-child {\n            .status::after {\n                background-color: #0080ff;\n                border: none;\n                width: 12px;\n                height: 12px;\n                content: \"\";\n                border-radius: 25px;\n                position: absolute;\n                top: -8px;\n                left: 0;\n                transition: all 200ms ease-in;\n            }\n        }\n    }\n\n    .bdp-view-details {\n        border-top: 2px solid #ddd;\n        text-align: center;\n        display: inline-block;\n        width: 100%;\n    }\n}\n\n::ng-deep {\n    .p-dialog .p-dialog-footer {\n        // text-align: left !important;\n\n        button {\n            width: 184px;\n        }\n\n        .bdp-save {\n            background-color: #2d74ff;\n        }\n\n        .bdp-reset {\n            color: #1d2125;\n            background-color: #fff;\n            border-color: #1d2125;\n        }\n    }\n\n    #timeline {\n        div.p-overlaypanel {\n            z-index: 1;\n            width: 870px;\n            // overflow-x: auto;\n            // overflow-y: hidden;\n            // top: 550px !important;\n            // left: 300px !important;\n            // height: 280px;\n\n            &::after {\n                content: \"\";\n            }\n\n            &::before {\n                content: \"\";\n            }\n\n            .p-overlaypanel-close {\n                background: none;\n                color: black;\n                width: 2rem;\n                height: 2rem;\n                transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n                border-radius: 50%;\n                position: absolute;\n                top: 0.4rem;\n                right: 0.2rem;\n            }\n\n            #bdpTimelineNoData {\n                color: #282c30;\n                margin: 30px 20px;\n                // text-align: center;\n                white-space: pre-line;\n                font-size: 14px;\n            }\n        }\n    }\n\n    div.p-overlaypanel {\n        z-index: 1;\n        // width: 870px;\n        // overflow-x: auto;\n        // overflow-y: hidden;\n        // top: 550px !important;\n        // left: 300px !important;\n        // height: 280px;\n\n        &::after {\n            content: \"\";\n        }\n\n        &::before {\n            content: \"\";\n        }\n\n        .p-overlaypanel-close {\n            background: none;\n            color: black;\n            width: 2rem;\n            height: 2rem;\n            transition: background-color 0.2s, color 0.2s, box-shadow 0.2s;\n            border-radius: 50%;\n            position: absolute;\n            top: 0.4rem;\n            right: 0.2rem;\n        }\n\n        #bdpTimelineNoData {\n            color: #282c30;\n            margin: 30px 20px;\n            // text-align: center;\n            white-space: pre-line;\n            font-size: 14px;\n        }\n    }\n\n    .bdp-favorite-button-font {\n        font-size: 12px;\n    }\n\n    .bdp-reset {\n        color: #1d2125;\n        background-color: #fff;\n        border-color: #1d2125;\n    }\n\n    .bdp-save {\n        background-color: #2d74ff;\n    }\n\n    .bdp-comment-length {\n        justify-content: flex-start;\n        margin-right: 50px;\n        margin-top: 6px;\n    }\n\n    .bdp-action-menu {\n        width: 265px;\n\n        &.p-menu .p-menuitem-link:not(.p-disabled):hover {\n            background: var(--bdpButtonHover);\n\n            .p-menuitem-text {\n                color: #fff;\n            }\n        }\n    }\n}\n\n.add-comments-area {\n    textarea {\n        width: 440px;\n        font-size: 14px;\n    }\n\n    // p {\n    //     min-width: 200px;\n    // }\n}\n\n::ng-deep .p-column-filter-overlay {\n    z-index: 99999 !important;\n}\n\n.p-input-icon-left i.pi {\n    position: absolute !important;\n    left: 2.75rem !important;\n    z-index: 1 !important;\n    margin-top: 8px !important;\n    color: var(--text-color-secondary);\n}  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
